import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ArticlesService } from 'src/app/services/articles/articles.service';
import { ImageService } from 'src/app/services/image/image.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.css'],
})
export class CareerComponent implements OnInit, OnDestroy {
  userLang = '';
  articles: any[] = [];
  isMobile = false;

  // تعريف الـ Breakpoints بشكل صحيح لـ PrimeNG
  responsiveOptions = [
    {
      breakpoint: '1200px',
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '1024px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '768px',
      numVisible: 1, // كارت واحد فقط في الموبايل
      numScroll: 1,
    },
  ];

  private readonly FALLBACK_IMAGE = 'assets/img/placeholder.png';
  private resizeListener!: () => void;

  constructor(
    private router: Router,
    private articleService: ArticlesService,
    private translate: TranslateService,
    private imageService: ImageService,
    private localizationService: LocalizationService,
    private cdr: ChangeDetectorRef,
  ) {
    this.userLang = this.localizationService.getUserLang();
  }
  ngOnInit(): void {
    this.checkMobile();
    this.resizeListener = () => this.checkMobile();
    window.addEventListener('resize', this.resizeListener);

    this.loadArticles();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLang = event.lang;
      this.loadArticles(); // re-filter on language switch
    });
  }

  private loadArticles(): void {
    this.articleService.getArticles().subscribe({
      next: (res: any) => {
        const all: any[] = res ?? [];
        this.articles = this.filterByLang(all).slice(0, 8);
      },
      error: (err) => console.error(err),
    });
  }

  private filterByLang(articles: any[]): any[] {
    return articles.filter((article) =>
      article?.translations?.some((t: any) => t.languageCode === this.userLang),
    );
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeListener);
  }

  checkMobile(): void {
    const width = window.innerWidth;
    this.isMobile = width <= 768;
    this.cdr.detectChanges();
  }

  loadArticleContent(article: any): string {
    const translation = article?.translations?.find(
      (t: any) => t.languageCode === this.userLang,
    );
    return translation?.title || article?.title || '';
  }

  loadArticleDesc(article: any): string {
    const translation = article?.translations?.find(
      (t: any) => t.languageCode === this.userLang,
    );
    return translation?.subtitle || article?.subtitle || '';
  }

  getFullImageUrl(relativeUrl: string): string {
    return this.imageService.handleImageUrl(
      this.imageService.getImagePath(relativeUrl),
    );
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = this.FALLBACK_IMAGE;
  }

  goToDetails(id?: number): void {
    if (id !== undefined) this.router.navigate(['/articleDetails', id]);
  }
}
